import React, { useContext, useEffect, useState } from "react";
import Modal from "../components/app/modal";
import axiosClient from "../axios/axiosClient";
import { toast } from "react-toastify";
import Pagination from "../components/app/pagination";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";

function SuperAdmin() {
  const { user } = useContext(AuthContext);
  const [modalTitle, setModalTitle] = useState("Create User");
  const [users, setUsers] = useState([]);
  const [editUserId, setEditUserId] = useState("");
  const [userAnalytics, setUserAnalytics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    gender: "",
    address: "",
    user_type: "project_officer", // Default value
  });

  const defaultUserType = user?.user_type === "super_admin" ? "admin" : "project_officer";

  const allowedUserTypes =
    user?.user_type === "super_admin"
      ? [
          { value: "admin", label: "Admin" },
        ]
      : [
          { value: "project_manager", label: "Project Manager" },
          { value: "case_manager", label: "Case Manager" },
          { value: "project_officer", label: "Project Officer" },
        ];

  const resetSetFormData = () => {
    setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        gender: "",
        address: "",
        user_type: defaultUserType, 
      })
      setEditUserId("")
  }

  // Handling change in input fields
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    let url = "/user/create";
    console.log(editUserId, "editUserId")
    if(editUserId){
        url = `/user/${editUserId}/update`
    }
    axiosClient
      .post(url, formData)
      .then((response) => {
        getUsers();
        getUsersAnalytics();
        toast.success(response.data.message);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const getUsers = (url = "/user/all") => {
    axiosClient
      .get(url)
      .then((response) => {
        setUsers(response.data.data.data);
        setPagination(response.data.data)
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const getUsersAnalytics = (url = "/user/analytics") => {
    axiosClient
      .get(url)
      .then((response) => {
        setUserAnalytics(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const resetPassword = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset Password!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
        .post(`/user/${id}/reset-password`)
        .then((response) => {
          toast.success(response.data.message);
        })
        .catch((error) => {
          toast.success(error.response.data.message);
        });
      } else {
        Swal.fire("Cancel!", "You cancelled reset password.", "error");
      }
    });
   
  };

const handlePageChange = (url) => {
    getUsers(url);
};

  useEffect(() => {
    setLoading(true);
    getUsers();
    getUsersAnalytics();
    // testPipeDrive();
  }, []);

  useEffect(() => {
    if (user?.user_type === "super_admin") {
      setFormData((prev) => ({ ...prev, user_type: "admin" }));
    }
  }, [user?.user_type]);

  return (
    <>
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>Manage Users</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i data-feather="home"></i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Users</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">
            Manage Users
            <div className="pull-right">
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#createUser"
                onClick={resetSetFormData}
              >
                Create User
              </button>
            </div>
          </h4>

          <div className="card-options">
            <a
              className="card-options-collapse"
              href="edit-profile.html#"
              data-toggle="card-collapse"
            >
              <i className="fe fe-chevron-up"></i>
            </a>
            <a
              className="card-options-remove"
              href="edit-profile.html#"
              data-toggle="card-remove"
            >
              <i className="fe fe-x"></i>
            </a>
          </div>
        </div>
        <div className="row">
            <div class="col-sm-6 col-xl-3 col-lg-6">
                <div class="card o-hidden">
                  <div class="bg-primary b-r-4 card-body">
                    <div class="media static-top-widget">
                      <div class="align-self-center text-center"><i data-feather="navigation"></i></div>
                      <div class="media-body"><span class="m-0">Total Users</span>
                        <h4 class="mb-0 counter">{userAnalytics?.all_users}</h4><i class="icon-bg" data-feather="navigation"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xl-3 col-lg-6">
                <div class="card o-hidden">
                  <div class="bg-secondary b-r-4 card-body">
                    <div class="media static-top-widget">
                      <div class="align-self-center text-center"><i data-feather="box"></i></div>
                      <div class="media-body"><span class="m-0">Project Manager</span>
                        <h4 class="mb-0 counter">{userAnalytics?.project_manager}</h4><i class="icon-bg" data-feather="box"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {user?.user_type === "super_admin" && (
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <div class="card o-hidden">
                    <div class="bg-info b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><i data-feather="shield"></i></div>
                        <div class="media-body"><span class="m-0">Admins</span>
                          <h4 class="mb-0 counter">{userAnalytics?.admin}</h4><i class="icon-bg" data-feather="shield"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div class="col-sm-6 col-xl-3 col-lg-6">
                <div class="card o-hidden">
                  <div class="bg-primary b-r-4 card-body">
                    <div class="media static-top-widget">
                      <div class="align-self-center text-center"><i data-feather="message-square"></i></div>
                      <div class="media-body"><span class="m-0">Case Manager</span>
                        <h4 class="mb-0 counter">{userAnalytics?.case_manager}</h4><i class="icon-bg" data-feather="message-square"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xl-3 col-lg-6">
                <div class="card o-hidden">
                  <div class="bg-primary b-r-4 card-body">
                    <div class="media static-top-widget">
                      <div class="align-self-center text-center"><i data-feather="users"></i></div>
                      <div class="media-body"><span class="m-0">Project Officer</span>
                        <h4 class="mb-0 counter">{userAnalytics?.project_officer}</h4><i class="icon-bg" data-feather="users"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
        <div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap">
            <thead>
              <tr>
                <th>ID</th>
                <th>Photo</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Gender</th>
                {/* <th>Address</th> */}
                <th>User Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => {
                    // Calculate the correct index based on current page
                    const currentPage = pagination.current_page;
                    const perPage = pagination.per_page;
                    const correctIndex = (currentPage - 1) * perPage + index + 1;

                    return (
                        <tr key={user.id}>
                            <td>{correctIndex}</td>
                            <td><img className="rounded-circle" style={{height:"50px"}} src={user.photo? user.photo:'../assets/images/avtar/user.jpeg'} alt="Photo" /></td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{user.gender}</td>
                            {/* <td>{user.address}</td> */}
                            <td>{user.user_type}</td>
                            <td>
                                <a class="icon" href="javascript:void(0)" data-bs-original-title="" title=""></a>
                                <a class="btn btn-primary btn-sm" href="javascript:void(0)" data-bs-original-title="" title="" data-bs-toggle="modal"data-bs-target="#createUser" onClick={() => {setModalTitle("Edit User"); setEditUserId(user.id); setFormData(user)}}><i class="fa fa-pencil"></i> Edit</a>
                                <a class="icon" href="javascript:void(0)" data-bs-original-title="" title=""></a>
                                <a class="btn btn-danger btn-sm" href="javascript:void(0)" onClick={() => {resetPassword(user.id) }}><i class="fa fa-pencil"></i> Reset Password</a>
                            </td>
                        </tr>
                    );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pull-right">
          <Pagination paginationData={pagination} onPageChange={handlePageChange} />
        </div>
      </div>

      <Modal
        title={modalTitle}
        onSave={handleSave}
        modalId="createUser"
        modalSize="lg"
        modalPosition="centered"
      >
        <div className="row g-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="first_name"
                placeholder="Enter first name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="last_name"
                placeholder="Enter last name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="text"
                className="form-control"
                id="phone"
                name="phone"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <select
                className="form-control"
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="others">Others</option>
              </select>
            </div>
          </div>

         
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="userType">User Type</label>
              <select
                className="form-control custom-select"
                id="userType"
                name="user_type"
                value={formData.user_type}
                onChange={handleChange}
              >
                {allowedUserTypes.map((roleOption) => (
                  <option key={roleOption.value} value={roleOption.value}>
                    {roleOption.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="userType">Address</label>
              <textarea className="form-control" id="address" name="address" onInput={handleChange}>
                {formData.address}
              </textarea>
              {/* <select
                className="form-control custom-select"
                id="userType"
                name="user_type"
                value={formData.user_type}
                onChange={handleChange}
              >
                <option value="project_manager">Project Manager</option>
                <option value="case_manager">Case Manager</option>
                <option value="project_officer">Project Officer</option>
              </select> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SuperAdmin;
